<script setup lang="ts">
import { ColorPicker } from '@progress/kendo-vue-inputs'
import { X } from 'lucide-vue-next'
import { addRange, removeRange } from '@/lib/range'
import Input from '@/components/ui/input/Input.vue'
import Label from '@/components/ui/label/Label.vue'
import Button from '@/components/ui/button/Button.vue'
import type { RangeColor } from '@/lib/types'

const props = defineProps<{
  settings: Record<string, RangeColor[]>
}>()
</script>

<template>
  <div class="flex-col gap-4" v-for="(setting, settingName) in props.settings" :key="settingName">
    <h1 class="font-bold">{{ settingName }}</h1>
    <div
      class="flex flex-row gap-4 mt-3 items-end min-w-[300px]"
      v-for="(range, rangeIndex) in setting"
      :key="rangeIndex"
    >
      <div class="flex flex-col gap-2">
        <Label for="name">Range {{ rangeIndex + 1 }}</Label>
        <div class="flex gap-2">
          <Input
            type="number"
            v-model="range.start_range"
            :default-value="range.start_range"
            class="h-8"
          />
          <Input
            type="number"
            v-model="range.end_range"
            :default-value="range.end_range"
            class="h-8"
          />
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <Label for="color">Couleur</Label>
        <ColorPicker
          v-model="range.color"
          :default-value="range.color"
          :key="range.color"
          class="h-8"
        />
      </div>
      <Button
        class="h-8"
        size="xs"
        variant="outline"
        @click="() => removeRange(setting, rangeIndex)"
      >
        <X />
      </Button>
    </div>
    <Button class="mt-3" variant="outline" @click="() => setting && addRange(setting)">
      Ajouter une range
    </Button>
  </div>
</template>
